
const addTransition = s => {
  s.transitionDuration = ".2s"
  s.transitionTimingFunction = "ease-in-out"
}

export default (enter = "enter", leave = "leave", targetProperty = "height", disabled) => ({
  methods: {
    [enter](el) {
      if (disabled && this[disabled]) return;

      const s = el.style
      const rect = el.getBoundingClientRect()

      s[targetProperty] = 0
      s.overflow = "hidden"

      requestAnimationFrame(() => {
        addTransition(s)
        s[targetProperty] = rect[targetProperty] + "px"

        const listener = () => {
          s[targetProperty] = "auto"
          s.overflow = ""
          s.transitionDuration = ""
          s.transitionTimingFunction = ""
        }

        el.addEventListener("transitionend", listener)
      })
    },
    [leave](el) {
      if (disabled && this[disabled]) return;

      const s = el.style
      const rect = el.getBoundingClientRect()

      s[targetProperty] = rect[targetProperty] + "px"
      s.overflow = "hidden"

      requestAnimationFrame(() => {
        addTransition(s)

        s[targetProperty] = 0

        const listener = () => {
          s[targetProperty] = "auto"
        }

        el.addEventListener("transitionend", listener)
      })

    },
  },
})
